// Code imported from the react-div-100vh library to resolve the mobile browser layout

import getWindow from '@loggi/js/get-window';
import { isMobile } from '@loggi/js/mobile';
import View from '@loggi/ui/components/view';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { removeBodyClass, setBodyClass } from 'shared/utils/body-attributes';
import convertStyle from 'shared/utils/convert-style/convert-style';

export default class MainView extends Component {
  constructor() {
    super();

    this.state = {
      style: {}
    };
  }

  componentDidMount() {
    setBodyClass([
      'small-device-no-header',
      'small-device-no-footer',
      'small-device-no-app-beyond'
    ]);

    this.updateStyle();
    window.addEventListener('resize', this.updateStyle);
  }

  componentWillUnmount() {
    removeBodyClass([
      'small-device-no-header',
      'small-device-no-footer',
      'small-device-no-app-beyond'
    ]);

    window.removeEventListener('resize', this.updateStyle);
  }

  getWindowHeight = () => getWindow().innerHeight;

  updateStyle = () => {
    const { style } = this.props;
    const convertedStyle = convertStyle(style, this.getWindowHeight());
    this.setState({ style: convertedStyle });
  };

  render() {
    const { className, children } = this.props;
    if (isMobile()) {
      const { style } = this.state;
      return (
        <View className={className} style={style}>
          {children}
        </View>
      );
    }
    return <View className={className}>{children}</View>;
  }
}

MainView.displayName = 'MainView';

MainView.propTypes = {
  style: PropTypes.shape({ height: PropTypes.string }),
  className: PropTypes.string,
  children: PropTypes.node
};

MainView.defaultProps = {
  style: { height: '100rvh' },
  className: null,
  children: null
};
